import { createAuthClient } from "better-auth/vue"

// 创建Better Auth Vue客户端
export const authClient = createAuthClient({
    baseURL: "https://auth-api.shennong.cc"
})

// 登录URL生成器
export const getLoginUrl = () => {
  return `https://auth-api.shennong.cc/auth/sign-in?redirectTo=https://bushou2.shennong.cc`;
};

// 获取当前用户session - 使用Better Auth的Vue Hook
export const useSession = () => {
  return authClient.useSession();
}

// 登出函数
export const signOut = async () => {
  try {
    const result = await authClient.signOut();
    return !result.error;
  } catch (error) {
    console.error('登出失败:', error);
    return false;
  }
}

// 重定向到登录页面
export const redirectToLogin = () => {
  window.location.href = getLoginUrl();
}